import React from "react";
import {NavLink} from "react-router-dom"

export default function MainServices() {
  return (
    <div>
      <section class="section-services">
        <div class="container">
          <div class="row justify-content-center text-center">
            <div class="col-md-10 col-lg-8">
              <div class="header-section">
          
              {/* <h2 className="display-6 text-center mb-4">Our <b>Awesome</b> Services </h2> */}

<h2 className="display-6 text-center mb-4">
  Our <span className="text-primary fw-bold blink">Awesome</span> Services
</h2>

              </div>
            </div>
          </div>
          
          <div class="row1" >
{/*             
            <div class="col-md-6 col-lg-4"  data-aos="zoom-in"  data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div class="single-service">
                <div class="content">
                  <span class="icon">
                    <i class="fa fa-laptop"></i>
                  </span>
                  <h3 class="title">AI-Driven Software Solutions with Multi-Channel Communication</h3>
                  <h2 class="description"> Transforming Business Operations with Smart Web Applications | Next-gen software development with integrated AI and multichannel communication </h2>
                  <h1 class="description"> Bytlas Intelligence delivers cutting-edge web applications that are scalable, secure, and AI-enabled. We integrate SMS, email, WhatsApp, and chatbots to ensure seamless communication across all platforms—tailored for enterprise needs.</h1>
                  <p class="description"> Bytlasintelligence-Digitalworld.</p>
                  <NavLink to="/AIDrivenSoftware" >
                    <span className="text-danger fw-bold blink">Learn More</span></NavLink>
                </div>
                <span class="circle-before "></span>
              </div>
            </div> */}


            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-danger">
                            <i className="fa-solid fa-code"></i>
                          </span>
                          <h3 className="title">AI-Driven Software Solutions with Multi-Channel Communication</h3>
                          <h2 className="description">Transforming Business Operations with Smart Web Applications | Next-gen software development with integrated AI and multichannel communication</h2>
                          <h1 className="description">Bytlas Intelligence delivers cutting-edge web applications that are scalable, secure, and AI-enabled. We integrate SMS, email, WhatsApp, and chatbots to ensure seamless communication across all platforms—tailored for enterprise needs.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/AIDrivenSoftware"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span>
              </div>
            </div>


            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-primary">
                            <i className="fa-solid fa-globe"></i>
                          </span>
                          <h3 className="title">AI-Enabled Website Designing with SEO</h3>
                          <h2 className="description">Modern Websites Built for Performance and Visibility | Crafting intelligent, SEO-ready websites that attract and convert.</h2>
                          <h1 className="description">Our team builds aesthetically pleasing, AI-powered websites optimized for search engines and integrated with the latest service APIs. Experience responsive design, fast load speeds, and improved online visibility.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/AIWebsiteDesignWithSEO"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span>
              </div>
            </div>


            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-secondary">
                            <i className="fa-solid fa-mobile-screen-button"></i>
                          </span>
                          <h3 className="title"> Mobile App Design & Development</h3>
                          <h2 className="description">Smart Mobile Apps for Every Sector | Custom mobile apps for BFSI, eCommerce, Travel, Education, Hospitality & Healthcare. </h2>
                          <h1 className="description">We develop intuitive Android & iOS apps tailored for diverse industries. With a focus on UX, security, and performance, our mobile solutions deliver seamless customer experiences that boost engagement and ROI.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/MobileAppDevelopment"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span> 
              </div>
            </div>
            

            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-info">
                            <i className="fa-solid fa-robot"></i>
                          </span>
                          <h3 className="title">RPA Automation Services</h3>
                          <h2 className="description">Automate Repetitive Tasks and Increase Productivity | Intelligent bots to handle recurring processes, saving time and cost. </h2>
                          <h1 className="description">Our Robotic Process Automation (RPA) services simplify operations by automating routine tasks like data entry, invoice processing, and scheduling—improving efficiency across business functions.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/RPASolutions"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span>
              </div>
            </div>


            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-warning">
                            <i className="fa-solid fa-chart-line"></i>
                          </span>
                          <h3 className="title">Business Intelligence with Microsoft Power BI</h3>
                          <h2 className="description">Turn Data into Action with Power BI | Empower your team to make informed, real-time decisions. </h2>
                          <h1 className="description">Bytlas offers Power BI implementation and corporate training led by certified professionals. Unlock deep data insights through interactive dashboards, reports, and visualizations tailored to your business goals.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/PowerBITraining"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span>
              </div>
            </div>                        

            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-success">
                            <i className="fa-solid fa-file-excel"></i>
                          </span>
                          <h3 className="title">Advanced MS Excel Dashboards & Corporate Training</h3>
                          <h2 className="description">Excel Mastery for Data-Driven Professionals | Custom dashboards, automation templates, and hands-on training for corporates. </h2>
                          <h1 className="description">From data scrubbing to dynamic reports, our Excel experts help businesses streamline data processing. We also provide training to upskill employees in advanced Excel techniques, pivot tables, macros, and more.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/ExcelDashboardTraining"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span>
              </div>
            </div>                        

            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-dark">
                            <i className="fa-solid fa-database"></i>
                          </span>
                          <h3 className="title">Database Management Solutions</h3>
                          <h2 className="description">Complete Control Over Your Data Assets | Secure, maintain, and restore any type of database with confidence.</h2>
                          <h1 className="description">We manage SQL, MySQL, MongoDB, and more—offering 24/7 monitoring, regular backups, optimization, and disaster recovery solutions for your mission-critical data infrastructure.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/DatabaseManagementSolutions"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span>
              </div>
            </div>                        


            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-primary">
                            <i className="fa-solid fa-chalkboard-teacher"></i>
                          </span>
                          <h3 className="title">Corporate Training Solutions</h3>
                          <h2 className="description">Upskill Your Workforce with Certified Experts | Customized corporate training led by professionals across domains. </h2>
                          <h1 className="description">From IT skills to soft skills, we offer workshops and long-term training programs designed to enhance employee productivity and alignment with your business objectives.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/CorporateTrainingSolutions"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span>
              </div>
            </div>                        


            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-danger">
                            <i className="fa-solid fa-brain"></i>
                          </span>
                          <h3 className="title">Data Analytics & AI Insights</h3>
                          <h2 className="description">Extract Intelligence from Every Byte | Uncover patterns, forecast trends, and drive data-based decisions. </h2>
                          <h1 className="description">Bytlas leverages AI and data science to offer analytics solutions that help identify opportunities, assess risk, and optimize business performance through structured reporting and predictive insights.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/DataAnalyticsAIInsights"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span>
              </div>
            </div>                        


            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-warning">
                            <i className="fa-solid fa-shield-halved"></i>
                          </span>
                          <h3 className="title">Cyber Security Training & Consulting</h3>
                          <h2 className="description">Defend Your Digital Future | Secure your enterprise with certified cyber professionals. </h2>
                          <h1 className="description">We provide cyber awareness training and strategic consulting delivered by certified experts with government collaboration experience. Services include audits, penetration testing, and compliance advisory.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/CyberSecurityTrainingConsulting"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span>
              </div>
            </div>                        


            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-muted">
                            <i className="fa-solid fa-server"></i>
                          </span>
                          <h3 className="title">IT Services</h3>
                          <h2 className="description">End-to-End IT Infrastructure & Support | Server, network, and database management under one roof. </h2>
                          <h1 className="description">Our team ensures robust IT operations—from server maintenance to database optimization, offering proactive support, patch management, and security compliance tailored for enterprise needs.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/ITServices"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span>
              </div>
            </div>                        


            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-danger">
                            <i className="fa-solid fa-photo-film"></i>
                          </span>
                          <h3 className="title">Social Media Multimedia Content Creation</h3>
                          <h2 className="description">Captivating Content That Speaks Your Brand | Custom-designed visuals, videos, logos & more. </h2>
                          <h1 className="description"> We craft engaging posters, reels, promotional videos, branding assets, and logo designs that elevate your digital presence and build brand recall across platforms.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/SocialMediaContentCreation"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span>
              </div>
            </div>                        


            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-primary">
                            <i className="fa-brands fa-facebook-messenger"></i>
                          </span>
                          <h3 className="title">Digital Media Marketing</h3>
                          <h2 className="description">Hands-Free Growth on Social Media | Professionally managed accounts to keep your brand active and engaging. </h2>
                          <h1 className="description">Let Bytlas manage your daily posts, interactions, analytics, and growth campaigns to ensure your brand maintains relevance and engagement across all key platforms.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/DigitalMediaMarketing"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span>
              </div>
            </div>                        


            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-success">
                            <i className="fa-solid fa-cart-shopping"></i>
                          </span>
                          <h3 className="title">eCommerce a (SaaS) – Shop Easy, Save Big</h3>
                          <h2 className="description">Launch Your Store the Smart Way | All-in-one SaaS eCommerce platform with Razorpay integration. </h2>
                          <h1 className="description">Bytlas provides a ready-to-launch eCommerce platform with secure payment gateway (Razorpay), product management, and marketing tools to help you scale online—fast and affordably.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/EcommerceSaaS"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span>
              </div>
            </div>                        

            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-warning">
                            <i className="fa-solid fa-briefcase"></i>
                          </span>
                          <h3 className="title">Jobs Portal – Where Talent Meets Opportunity</h3>
                          <h2 className="description">Empowering Careers, Connecting Companies | A free platform for jobseekers and recruiters to connect. </h2>
                          <h1 className="description">Our job portal allows companies to post openings and candidates to apply—completely free. With smart search and resume management, we bridge the talent gap with ease.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/JobsPortal"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span>
              </div>
            </div>                        


            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-info">
                            <i className="fa-solid fa-gears"></i>
                          </span>
                          <h3 className="title">Digitalization & Process Automation</h3>
                          <h2 className="description"> Digitally Transform Your Business Processes | Paperless workflows and automated systems for growth. </h2>
                          <h1 className="description">From document management to e-approvals, we implement digital solutions that reduce manual intervention, increase compliance, and improve turnaround time across departments.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/DigitalizationProcessAutomation"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span>
              </div>
            </div>                        

            <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-duration="500" data-aos-easing="ease-in-quad">
              <div className="single-service">
                  <div className="content">
                          <span className="icon text-primary">
                            <i className="fa-solid fa-handshake"></i>
                          </span>
                          <h3 className="title">Business Consultancy Services</h3>
                          <h2 className="description"> Your Growth Partner in Every Step | Strategic advice for revenue acceleration and cost optimization. </h2>
                          <h1 className="description">Bytlas delivers result-driven consultancy to improve profit margins, streamline operations, and build future-ready business models. We combine data, tech, and domain expertise for maximum impact.</h1>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <p className="description mb-0 text-end">Bytlasintelligence-Digitalworld.</p>
                            <NavLink to="/BusinessConsultancyServices"><span className="text-danger fw-bold blink">Learn More</span></NavLink>
                          </div>
                    </div>
                        <span className="circle-before"></span>
              </div>
            </div>                        




          </div>
        </div>
      </section>
    </div>
  );
}
